import React from 'react'
import { SKETCH_WEBSITE } from '@sketch/env-config'

import { NoticeContentTemplateWithOptionalActionAndLearnMore } from '../NoticeContentTemplates'
import { WorkspaceSidebarNoticeContainer } from '../WorkspaceSidebarNoticeContainer'
import { ReactComponent as PersonalWorkspaceIcon } from '@sketch/icons/workspace-17'
import * as S from './WorkspaceSidebarNoticeSubscriptionUnavailable.styles'

export function WorkspaceSidebarNoticeSubscriptionUnavailable() {
  return (
    <WorkspaceSidebarNoticeContainer>
      <NoticeContentTemplateWithOptionalActionAndLearnMore
        learnMoreLink={{
          href: `${SKETCH_WEBSITE}/partners/directory/`,
          external: true,
        }}
        icon={PersonalWorkspaceIcon}
        title="Direct Purchase Unavailable"
      >
        <S.UpgradeParagraph>
          Sketch purchases and renewals are unavailable in your region.
        </S.UpgradeParagraph>
        <S.UpgradeParagraph>
          You may be able to purchase via a&nbsp;partner.
        </S.UpgradeParagraph>
      </NoticeContentTemplateWithOptionalActionAndLearnMore>
    </WorkspaceSidebarNoticeContainer>
  )
}
